
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import {
    saveCollection,
    saveFootPrint,
    getJsInfo,
    getIndexMapUrl,
    sendQrpvCount,
    submitListenRecord,
    getBagDetail,
    getisSubscribe,
    getuploadossKey,
    saveTouristStay,
    getVerificationCode,
    userLogin
} from "@/service/index";
import comm from "@/util/common";
import CONFIG from "@/util/config";
import Weixin from "@/util/user";
// import socketio from 'socket.io-client';
declare let AMap: any;
declare let qq: any;
declare let wx: any;
declare global {
    // 251028
    interface Window {
        mapObject: any;
        arrowImgLayer: any;
    }
}
import { Toast } from "vant";
import axios from "axios";
Vue.use(Toast);
interface bagData {
    isbuy: boolean;
    title: string;
    num: string | number;
    voicePacketId: string | number;
}
@Component({
    components: {}
})
export default class App extends Vue {
    $refs!: {
        loginFormRef: HTMLFormElement;
        audio: HTMLFormElement;
        jpjsAudio: HTMLElement; // 251028
    };
    // 手机验证弹窗表单
    private loginForm: any = {
        tel: "", //电话号码
        verificationCode: "", //表单中展示的验证码
        contenttext: "", //向手机号发送的随机验证码
        timer: null, //倒计时时间
        showloginCode: true, //判断展示‘获取验证码’或‘倒计时’
        count: "", //倒计时时间
        verification: "发送验证码", //验证码
        title: ``
    };
    private isabled = false; //是否禁用发送验证码按钮
    private routerUrl: any; //用户登录后要跳转的页面
    private socket: any;
    private CodeFlag = false;

    // socket.on('loginAck',(data)=> {})
    // private io:Socket
    created() {
        setTimeout(() => {
            this.CodeFlag = true;
        }, 1000);
        if (this.getQueryVariable("vcode")) {
            localStorage.setItem("vcode", this.getQueryVariable("vcode"));
        }
        if (this.getQueryVariable("token")) {
            localStorage.setItem(
                "token" + localStorage.getItem("vcode"),
                this.getQueryVariable("token")
            );
        }
        if (this.getQueryVariable("openId")) {
            localStorage.setItem("openId", this.getQueryVariable("openId"));
        }
        // 重置是否在景区标识
        localStorage.setItem("inSenic", "false");
        // 获取、校验token 及获取用户信息
        Weixin.getUserInfo();
    }
    mounted() {
        this.initLocation();
        // this.getJsInfo();
        // 若为扫描二维码进入页面 则调用接口进行统计
        // let qrCode = this.getQueryVariable("qrcode");
        // if (qrCode) {
        //   sendQrpvCount({ qrCode: qrCode });
        // }
        // 微信浏览器中 或是导览页、景点详情页 是否关注公众号，未关注则弹窗提示关注
        // if (
        //   comm.isWechatBrowsers() &&
        //   this.$store.state.firstShowAD &&
        //   (this.$route.name === "scenic-guide" ||
        //     this.$route.name === "scenic-detial-info")
        // ) {
        //   getisSubscribe().then((res: any) => {
        //     if (res.code === 0 && !res.data.subscribe && res.data.subscribeBiz) {
        //       this.$dialog
        //         .confirm({
        //           message: "关注公众号\n随时访问景区资源？",
        //           confirmButtonText: "去关注"
        //         })
        //         .then(() => {
        //           window.location.href = decodeURIComponent(res.data.subscribeBiz);
        //         });
        //       this.$store.commit("setFirstShowAD");
        //     }
        //   });
        // }
        // 计算用户位置是否在某个景点范围
        setInterval(() => {
            this.computeInSecnic();
        }, 30 * 1000);
        this.animatArrowImg();
        // 解决ios软键盘收起后，body被顶起不回落，使底部按钮点击失败
        document.body.addEventListener("focusout", () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        });
    }
    // 验证手机号是否合法
    private checkMobile = (value: any) => {
        if (value) {
            return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                value
            );
        }
    };
    // 验证输入的手机号验证码是否和存储的验证码相同
    private checkPhoneCode = (value: any, callback: any) => {};
    @Provide() onSubmit() {
        if (!this.loginForm.verificationCode) {
            this.$toast("请输入验证码");
            return;
        }
        let loginVO: object = {
            code: this.loginForm.verificationCode,
            phone: this.loginForm.tel
        };
        userLogin(loginVO).then(res => {
            // console.log(res.code)
            if (res.code === 0) {
                this.$store.commit("setShowVerification", false);
                this.$toast("登陆成功!");
                this.$store.commit("setUserInfo", res.data);
                // 修改状态为已登录
                this.$store.commit("setLoginState", true);
                //保存用户信息
                localStorage.setItem("phone", res.data.phone);
                localStorage.setItem("nickname", res.data.nickname);
                localStorage.setItem("sex", res.data.sex || "");
                localStorage.setItem("userSn", res.data.userSn);
                this.$store.commit("setUserInfo", res.data);
                // 保存token
                localStorage.setItem("token", res.data.token);
                // 刷新当前页面
                // this.$router.go(0)
                if (this.$store.state.routerPath !== "/scenic-guide") {
                    if (this.routerUrl) {
                        this.$router.push(this.routerUrl);
                    } else {
                        this.$router.go(0);
                    }
                }
            } else {
                this.$toast(res.message);
            }
        });
    }
    //取消，隐藏验证码弹窗
    @Provide() cancel() {
        this.loginForm.verificationCode = "";
        this.loginForm.tel = "";
        this.$refs.loginFormRef.resetValidation();
        // 清除倒计时
        this.loginForm.showloginCode = true;
        clearInterval(this.loginForm.timer);
        this.loginForm.timer = null;
        this.isabled = false;
        this.$store.commit("setShowVerification", false);

        if (
            this.$store.state.routerPath !== "/scenic-guide" &&
            this.$store.state.routerPath !== "/scenic-detial-info"
        ) {
            if (
                this.$store.state.routerPath === "/edit-profile" ||
                this.$store.state.routerPath === "/personal-page"
            ) {
                this.$router.push({ path: "/scenic-guide" });
            } else if (
                this.$store.state.routerPath.indexOf("/activity-detial") < 0
            ) {
                this.$router.go(-1);
            }
        }
        if (this.$store.state.routerPath.indexOf("/guide-album") > -1) {
            this.$router.replace({ path: "/scenic-guide" });
        }
    }
    @Provide() setWebTitle() {
        let title = localStorage.getItem("webTitle");
        document.getElementsByTagName("title")[0].innerText = `${title}`;
    }
    // 获取手机验证码
    @Provide() getloginPhoneCode(e: any) {
        // 如果未输入手机号，结束执行
        if (!this.loginForm.tel) {
            return;
        } else {
            // 获取验证码之前校验手机号是否输入正确
            if (!this.checkMobile(this.loginForm.tel)) {
                return;
            }
        }
        // 当点击发送验证码后，开始60秒倒计时
        const TIME_COUNT = 60;
        // 调用接口，向手机号发送验证码
        getVerificationCode({ phone: this.loginForm.tel }).then(res => {
            if (res.code === 0) {
                if (res.data) {
                    this.$toast(`验证码发送成功!`);
                    this.isabled = true;
                    if (!this.loginForm.timer) {
                        this.loginForm.showloginCode = false;
                        this.loginForm.count = TIME_COUNT;
                        this.loginForm.timer = setInterval(() => {
                            if (
                                this.loginForm.count > 0 &&
                                this.loginForm.count <= TIME_COUNT
                            ) {
                                this.loginForm.count -= 1;
                            } else {
                                this.loginForm.showloginCode = true;
                                clearInterval(this.loginForm.timer);
                                this.loginForm.timer = null;
                                this.isabled = false;
                            }
                        }, 1000);
                    }
                } else {
                    this.$toast("验证码发送失败!");
                    this.loginForm.verification = "重新发送";
                    return;
                }
            } else {
                this.$toast(`${res.message}!`);
                return;
            }
        });
    }
    // 验证用户是否登录
    @Provide() verifyLogin(routerUrl: any) {
        this.$router.push(routerUrl);
        // if (!localStorage.getItem("phone")) {
        //   this.routerUrl = routerUrl;
        //   this.$store.commit("setShowVerification", true);
        // } else {
        //   this.$router.push(routerUrl);
        // }
    }
    /* 获取url中参数 */
    @Provide() getQueryVariable(variable: string) {
        return (
            decodeURIComponent(
                // @ts-ignore url解码中文字符
                (new RegExp(
                    "[?|&]" + variable + "=" + "([^&;]+?)(&|#|;|$)"
                ).exec(location.href) || [, ""])[1].replace(/\+/g, "%20")
            ) || ""
        );
    }
    // 数字格式化
    @Provide() formatDigital(number: number | string) {
        let result = number;
        if (!number) {
            return result;
        }
        let numberStr = number.toString();
        let pointIndex = numberStr.indexOf(".");
        let lastIndex = numberStr.length - 1;
        let point = numberStr.substr(pointIndex, lastIndex);
        if (pointIndex >= 0) {
            lastIndex = pointIndex - 1;
        }
        result = "";
        let count = 1;
        for (let i = lastIndex; i >= 0; i--, count++) {
            let temp = numberStr[i];
            result = temp + result;
            if (count % 3 === 0 && i !== 0) {
                result = "," + result;
            }
        }
        if (pointIndex >= 0) {
            return result + point;
        } else {
            return result;
        }
    }
    /**
     * 添加收藏
     * resourceId: 资源ID
     * type: 1 收藏   0取消收藏
     */
    @Provide() saveCollection(
        resourceId: number | string,
        type: number | string = 1
    ) {
        this.$store.commit("showOverlay");
        saveCollection({
            openId:
                localStorage.getItem("openId") ||
                this.$store.state.openId ||
                "",
            resourceId: resourceId,
            type: type
        }).then((res: any) => {
            this.$store.commit("hideOverlay");
            if (res.code === 0) {
                this.$router.push({ path: "/collection" });
                Toast("收藏成功");
            } else {
                Toast(res.message);
            }
        });
    }
    /**
     * 两地之间的距离
     * @param lon1
     * @param lat1
     * @param lon2
     * @param lat2
     */
    @Provide() getDistance(
        lng1: string,
        lat1: string,
        lng2?: string,
        lat2?: string
    ) {
        // 只传一组经纬度时，将第二组经纬度设置为当前定位的位置
        if (!lng2 && !lat2) {
            lng2 = localStorage.getItem("lng") || this.$store.state.lng;
            lat2 = localStorage.getItem("lat") || this.$store.state.lat;
        }
        // 如果经纬度为空
        if (!lng1 || !lat1 || !lng2 || !lat2) {
            return "";
        }
        let p1 = [lng1, lat1];
        let p2 = [parseFloat(lng2), parseFloat(lat2)];
        let dis = AMap.GeometryUtil.distance(p1, p2);
        // @ts-ignore
        return parseFloat(dis / 1000).toFixed(2) + "km";
    }
    @Provide() getDistanceNum(
        lng1: string,
        lat1: string,
        lng2?: string,
        lat2?: string
    ) {
        // 只传一组经纬度时，将第二组经纬度设置为当前定位的位置
        if (!lng2 && !lat2) {
            lng2 = localStorage.getItem("lng") || this.$store.state.lng;
            lat2 = localStorage.getItem("lat") || this.$store.state.lat;
        }
        // 如果经纬度为空
        if (!lng1 || !lat1 || !lng2 || !lat2) {
            return 99999;
        }
        let p1 = [lng1, lat1];
        let p2 = [parseFloat(lng2), parseFloat(lat2)];
        let dis = AMap.GeometryUtil.distance(p1, p2);
        return dis;
    }
    /**
     * 跳转金牌解说购买页面
     * voicePacketId: 语音包id
     */
    private jpjsData = {
        showjpjsPay: false,
        title: "",
        num: 0,
        voicePacketId: ""
    };
    // 确定跳转支付页
    private confirmPay() {
        let voicePacketId = this.jpjsData.voicePacketId;
        let jpjsPayUrl = this.$store.state.jpjsPayUrl || "";
        let notifyUrl = this.$store.state.notifyUrl || "";
        if (
            jpjsPayUrl &&
            notifyUrl &&
            voicePacketId &&
            !this.$store.state.showOverlay
        ) {
            let callbackApi = `${notifyUrl}?ytyOpenId=${localStorage.getItem(
                "userSn"
            )}&vcode=${localStorage.getItem(
                "vcode"
            )}&voicePacketId=${voicePacketId}&token=${localStorage.getItem(
                "token"
            )}&pageUrl=${encodeURIComponent(window.location.href)}`;
            let reUrl = `${jpjsPayUrl}?id=${voicePacketId}&openid=${localStorage.getItem(
                "userSn"
            )}&headimg=${encodeURIComponent(
                localStorage.getItem("avatar") ||
                    this.$store.state.userInfo.avatar
            )}&notifyurl=${encodeURIComponent(
                callbackApi
            )}&name=${localStorage.getItem("nickname")}`;
            // alert(reUrl);
            this.$store.commit("showOverlay");
            setTimeout(() => {
                this.$store.commit("hideOverlay");
            }, 1000);
            window.location.href = reUrl;
        }
    }
    // 是否直接点击购买按钮
    private isgotoby = false;
    // 设置对应专辑信息
    @Provide() gotoJpjsPay(data: {
        title: string;
        num: string | number;
        voicePacketId: string | number;
        gotoBuy?: boolean;
    }) {
        if (event) {
            // @ts-ignore
            event.stopPropagation();
        }
        this.isgotoby = data.gotoBuy ? true : false;
        Object.assign(this.jpjsData, data);
        this.jpjsData.showjpjsPay = true;
    }
    /* S 定位 */
    private geolocation: any = {};
    private initLocation() {
        // 初始化后获取一次定位信息
        this.getNowLon();
    }

    private getNowLon() {
        var map = new AMap.Map("map", {
            resizeEnable: true
        });
        let _this = this;
        AMap.plugin("AMap.Geolocation", function() {
            let geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, //是否使用高精度定位，默认:true
                timeout: 10000, //超过10秒后停止定位，默认：5s
                buttonPosition: "RB", //定位按钮的停靠位置
                buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
            });
            map.addControl(geolocation);
            geolocation.getCurrentPosition();

            geolocation.getCurrentPosition(function(status: any, result: any) {
                console.log(status, result);

                if (status == "complete") {
                    onComplete(result);
                }
            });
            // AMap.event.addListener(geolocation, "complete", onComplete);

            function onComplete(data: any) {
                // data是具体的定位信息

                _this.$store.commit("setLocationLngLat", {
                    lng: data.position.lng,
                    lat: data.position.lat
                });
                // 经纬度也写入到local里面去
                localStorage.setItem("lng", data.position.lng);
                localStorage.setItem("lat", data.position.lat);
            }
        });
    }
    // 获取定位
    @Provide() getCurrentPosition() {
        let _this = this;
        this.geolocation.getLocation(showPosition, showErr);
        function showPosition(position: any) {
            //  alert(position.lng + "," + position.lat);
            _this.$store.commit("setLocationLngLat", {
                lng: position.lng,
                lat: position.lat
            });
            // 经纬度也写入到local里面去
            localStorage.setItem("lng", position.lng);
            localStorage.setItem("lat", position.lat);
        }

        function showErr() {
            console.log("定位失败");
            // _this.getCurrentPosition(); //定位失败再请求定位，测试使用
        }
    }
    // 判断是否在景区 返回1 表示未获取到经纬度
    @Provide() private getIndexMapUrl(boundsLimit: any) {
        if (boundsLimit) {
            // 有本地边界时，本地判断
            if (localStorage.getItem("lng") && localStorage.getItem("lat")) {
                if (
                    boundsLimit.contains([
                        localStorage.getItem("lng"),
                        localStorage.getItem("lat")
                    ])
                ) {
                    localStorage.setItem("inSenic", "true");
                } else {
                    localStorage.setItem("inSenic", "false");
                }
                console.log("是否在景区：" + localStorage.getItem("inSenic"));
            } else {
                if (comm.isWechatBrowsers()) {
                    this.$dialog.confirm({
                        message: "未获取到定位权限，请重启微信后再尝试",
                        showCancelButton: false
                    });
                } else {
                    this.$dialog.confirm({
                        message: "请检查位置服务是否开启",
                        showCancelButton: false
                    });
                }
                return 1;
            }
        } else {
            // 无本地边界，调用接口获取
            getIndexMapUrl({
                longitude: this.$store.state.lng,
                latitude: this.$store.state.lat
            }).then((res: any) => {
                if (res.code === 0 && res.data.isInScenicScope) {
                    // 在景区时
                    localStorage.setItem("inSenic", "true");
                    try {
                        // @ts-ignore
                        localStorage.setItem(
                            "vcode",
                            res.data.scenicList[0].vcode || ""
                        );
                        this.$store.commit(
                            "setVcode",
                            res.data.scenicList[0].vcode || ""
                        );
                    } catch (e) {
                        console.log("判断景区接口错误，重置为未在景区");
                        localStorage.setItem("inSenic", "false");
                    }
                }
            });
        }
    }
    /* E 定位 */
    /* S 线路规划 跳转高德 */
    @Provide() private getPathLine(
        lng: string | number,
        lat: string | number,
        name: string
    ) {
        this.$dialog
            .confirm({
                message: "是否导航至目的地？",
                confirmButtonText: "导航",
                closeOnClickOverlay: true
            })
            .then(() => {
                this.$store.commit("showOverlay");
                setTimeout(() => {
                    this.$store.commit("hideOverlay");
                }, 500);
                // v2.0 脱离微信
                // if (comm.isWechatBrowsers()) {
                //   console.log(lng)
                //   wx.openLocation({
                //     latitude: parseFloat(`${lat}`), // 纬度，浮点数，范围为90 ~ -90
                //     longitude: parseFloat(`${lng}`), // 经度，浮点数，范围为180 ~ -180。
                //     name: name, // 位置名
                //     address: "", // 地址详情说明
                //     scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
                //     infoUrl: location.href // 在查看位置界面底部显示的超链接,可点击跳转
                //   });
                // } else {
                let url = `https://m.amap.com/navigation/carmap/saddr=&daddr=${`${lng}`},${lat},${name ||
                    "目的地"}&src=nyx_super`;
                window.location.href = decodeURIComponent(url);
                // }
            })
            .catch(() => {});
    }
    /* E 线路规划 跳转高德 */
    /* S 图片预览 */
    private imagePreview = {
        index: 1,
        images: [] as Array<string>
    };
    // 图片切换时
    private imagePreviewOnChange(index: number) {
        this.imagePreview.index = index + 1;
    }
    // 点击查看图片
    @Provide() openPreview(list: Array<string>) {
        let newList = list.map((item: any) => {
            return item.url;
        });
        this.$store.commit("setShowimagePreview", true);
        this.imagePreview.images = newList;
    }
    // 点击查看图片2
    @Provide() openPreview2(list: Array<string>) {
        let newList = list.map((item: any) => {
            return item;
        });
        this.$store.commit("setShowimagePreview", true);
        this.imagePreview.images = newList;
    }
    /* E 图片预览 */
    // 获取微信配置
    private wxsdkSign: any = "";
    private singError = "false"; // 微信授权失败 与否
    private getJsInfo() {
        let _this = this;
        if (comm.isWechatBrowsers() && !this.wxsdkSign) {
            getJsInfo({
                url: window.location.href.split("#")[0],
                error: this.singError
            }).then((res: any) => {
                // 成功时
                if (res.code === 0 && res.data) {
                    let sdkSign = res.data; // 后台返回的值
                    this.wxsdkSign = res.data;
                    wx.config({
                        debug: false, // 因为在手机上测试没法打印，当debug为true时，所有的返回值都会在手机上alert出来
                        appId: sdkSign.appId, // 必填，公众号唯一标识
                        timestamp: sdkSign.timestamp, // 必填，生成签名的时间戳
                        nonceStr: sdkSign.nonceStr, // 必填，生成签名的随机串
                        signature: sdkSign.signature, // 必填，签名
                        jsApiList: [
                            "getLocation",
                            "openLocation",
                            "onMenuShareTimeline",
                            "onMenuShareAppMessage"
                        ] // 必填，需要使用的JS接口列表，需要用到什么接口就去开发者文档查看相应的字段名
                    });
                    wx.ready(function() {
                        console.log("签名成功");
                        wx.getLocation({
                            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                            success: function(res: any) {
                                // console.log(res);
                                let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                                let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                                // console.log(latitude, longitude);
                            },
                            fail: (res: any) => {
                                _this.$dialog.confirm({
                                    message:
                                        "请检查位置服务是否开启，或重启微信尝试",
                                    showCancelButton: false
                                });
                            }
                        });
                        if (sdkSign.share) {
                            let _url = window.location.href;
                            let url =
                                _url.indexOf("?") !== -1
                                    ? _url.split("?")[0]
                                    : _url;
                            let img = sdkSign.share.imgUrl;
                            let desc = sdkSign.share.desc;
                            let shareTitle = sdkSign.share.title;
                            wx.onMenuShareTimeline({
                                title: shareTitle, // 分享标题
                                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: img, // 分享图标
                                success: function() {
                                    // 用户点击了分享后执行的回调函数
                                }
                            });
                            wx.onMenuShareAppMessage({
                                title: shareTitle, // 分享标题
                                desc: desc, // 分享描述
                                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: img, // 分享图标
                                success: function() {}
                            });
                        }
                    });
                    // 失败以后重新调用 授权方法 ,并控制只调用一次
                    wx.error(function(res: any) {
                        _this.wxsdkSign = "";
                        console.log("签名失败");
                        if (_this.singError === "false") {
                            _this.singError = "true";
                            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            _this.getJsInfo();
                        }
                    });
                }
            });
        }
    }
    /* S 播放音乐 */
    private playStatus = false; // 是否正在播放
    private bagData: any = "";
    // 播放音频
    @Provide() playJPJSVoice(url: string, data: bagData) {
        this.bagData = data;
        if (!data.isbuy) {
            // 清空定时器
            this.clearAudioTimer();
            // 重复点击同一个音频  则停止播放
            if (this.$store.state.audioData.playUrl === url) {
                if (this.$store.state.audioData.playStatus) {
                    this.pauseAudio();
                } else {
                    // @ts-ignore
                    this.$refs.audio.play();
                    this.$store.commit("setAudioPlayStatus", true);
                    this.$store.commit("setTryStatus", false);
                }
            } else {
                this.$store.commit("setAudioData", {
                    playUrl: url,
                    title: data.title
                });
                this.timeoutPlay();
                this.$store.commit("setTryStatus", false);
                // 提交播放记录
                submitListenRecord({
                    id: data.voicePacketId,
                    openId: localStorage.getItem("openId")
                });
                // 设置专辑ID
                this.$store.commit("setAudioBagID", data.voicePacketId || "");
            }
        } else {
            // 未购买则跳转购买链接
            this.gotoJpjsPay({
                title: data.title,
                num: data.num,
                voicePacketId: data.voicePacketId
            });
        }
    }
    // 播放 试听音频
    private tryaudioTimer: any = 0;
    private tryTimeout: any = 0; // 试听时长定时器
    @Provide() tryplayJPJSVoice(url: string, data: bagData) {
        this.$store.commit("setTryStatus", true);
        this.bagData = data;
        // 清空定时器
        this.clearAudioTimer();
        this.$store.commit("setAudioData", { playUrl: url, title: data.title });
        let _this = this;
        this.tryaudioTimer = setTimeout(() => {
            let audio = document.getElementById("audio");
            // @ts-ignore
            audio.play();
            _this.$store.commit("setAudioPlayStatus", true);
            _this.tryTimeout = setTimeout(() => {
                // 试听结束后 弹出购买提示
                _this.gotoJpjsPay({
                    title: data.title,
                    num: data.num,
                    voicePacketId: data.voicePacketId
                });
                // 停止播放
                _this.stopAudio();
            }, 30 * 1000);
            // @ts-ignore 试听播放完成后关闭定时器 并弹出购买提示
            audio.onended = () => {
                _this.stopAudio();
                // 试听结束后 弹出购买提示
                _this.gotoJpjsPay({
                    title: data.title,
                    num: data.num,
                    voicePacketId: data.voicePacketId
                });
            };
        }, 100);
        // 提交播放记录
        submitListenRecord({
            id: data.voicePacketId,
            type: 1,
            openId: localStorage.getItem("openId")
        });
        // 设置专辑ID
        this.$store.commit("setAudioBagID", data.voicePacketId || "");
    }
    // 延迟触发一个播放事件，不然移动端有的会无法播放
    private audioTimer: any = 0;
    private timeoutPlay() {
        let _this = this;
        this.clearAudioTimer();
        if (this.$store.state.audioData.tryPlay) {
            // 若为试听时触发播放 跳转支付
            this.gotoJpjsPay({
                title: this.bagData.title,
                num: this.bagData.num,
                voicePacketId: this.bagData.voicePacketId
            });
        } else {
            this.audioTimer = setTimeout(() => {
                let audio = this.$refs.audio;
                // @ts-ignore
                audio.play();
                // @ts-ignore 播放完成
                audio.onended = () => {
                    _this.stopAudio();
                };
                this.$store.commit("setAudioPlayStatus", true);
            }, 100);
        }
    }
    @Provide() pauseAudio() {
        // @ts-ignore
        this.$refs.audio.pause();
        // 清空定时器
        this.clearAudioTimer();
        this.$store.commit("setAudioPlayStatus", false);
    }
    // 停止播放
    @Provide() stopAudio() {
        this.clearAudioTimer();
        // @ts-ignore
        this.$refs.audio.currentTime = 0;
        // @ts-ignore
        this.$refs.audio.pause();
        this.$store.commit("setAudioPlayStatus", false);
    }
    // 下一首
    private nextAudio() {
        // 专辑列表多于一条时
        if (this.$store.state.audioData.list.length > 1) {
            if (this.$store.state.audioData.tryPlay) {
                // 若为试听时触发播放 跳转支付
                this.gotoJpjsPay({
                    title: this.bagData.title,
                    num: this.bagData.num,
                    voicePacketId: this.bagData.voicePacketId
                });
            } else {
                // 先重新排列
                this.reSortLst(this.$store.state.audioData.list);
                // 设置播放信息
                let data = this.$store.state.audioData.list[1];
                this.$store.commit("setAudioData", {
                    playUrl: data.url,
                    title: data.spotname
                });
                this.timeoutPlay();
            }
        }
    }
    // 上一首
    private prveAudio() {
        // 专辑列表多于一条时
        if (this.$store.state.audioData.list.length > 1) {
            if (this.$store.state.audioData.tryPlay) {
                // 若为试听时触发播放 跳转支付
                this.gotoJpjsPay({
                    title: this.bagData.title,
                    num: this.bagData.num,
                    voicePacketId: this.bagData.voicePacketId
                });
            } else {
                // 先重新排列
                this.reSortLst(this.$store.state.audioData.list);
                // 设置播放信息
                let list = this.$store.state.audioData.list;
                // 上一首时  将列表最后一条重新拉回数组第一条
                let data = list[list.length - 1];
                this.$store.commit("setAudioData", {
                    playUrl: data.url,
                    title: data.spotname
                });
                this.timeoutPlay();
            }
        }
    }
    // 将当前播放的专辑列表重新排序
    private reSortLst(list: Array<any>) {
        let newList: Array<any> = [],
            _this = this;
        let currIndex = 0; // 在列表中查找到当前播放的音频的索引
        list.forEach((item: any, index: number) => {
            // 当前音频索引
            if (_this.$store.state.audioData.title == item.spotname) {
                currIndex = index;
            }
        });
        newList = list.slice(currIndex).concat(list.slice(0, currIndex));
        this.$store.commit("setAudioList", newList);
        return newList;
    }
    // 清除音频相关定时器
    private clearAudioTimer() {
        clearTimeout(this.tryaudioTimer);
        clearTimeout(this.audioTimer);
        clearTimeout(this.tryTimeout);
    }
    // 当播放专辑ID变化时  获取专辑对应的解说列表 ; 试听不触发此方法
    @Watch("$store.state.audioData.bagID")
    getNewAudioList(id: number | string) {
        this.getBagDetail(id);
    }
    // 获取语音包详情
    @Provide() private getBagDetail(id: number | string) {
        getBagDetail({
            id: id || "",
            openId: localStorage.getItem("openId")
        }).then((res: any) => {
            // 生成专辑列表
            this.$store.commit(
                "setAudioList",
                this.getVioceList(res.data.voice)
            );
            // 设置专辑图片
            this.$store.commit("setAudioImg", res.data.bag.headimg || "");
        });
    }
    // 重新遍历并生成解说语音列表
    private getVioceList(voiceList: Array<any>) {
        let list: Array<any> = [],
            _this = this;
        voiceList.forEach((item: any) => {
            list.push({
                spotname: item.name,
                url: item.url,
                id: item.id
            });
        });
        return list;
    }
    private panActive = false; // 是否展开音乐播放面板
    private startY = 0; // 开始移动的位置
    private moveY = 0; // 移动的距离
    private touchStart(e: any) {
        const ev = e || event;
        if (ev.touches.length) {
            console.log(ev);
            // @ts-ignore
            this.$refs.jpjsAudio.style.top = `${this.$refs.jpjsAudio.offsetTop}px`;
            // @ts-ignore
            this.$refs.jpjsAudio.style.bottom = "unset";
            // @ts-ignore
            this.$refs.jpjsAudio.style.transition = "unset";
            this.startY = ev.touches[0].clientY;
        }
    }
    private touchMove(e: any) {
        const ev = e || event;
        if (ev.touches.length) {
            this.moveY = ev.touches[0].clientY - this.startY;
            this.startY = ev.touches[0].clientY;
            // @ts-ignore
            this.$refs.jpjsAudio.style.top = `${parseInt(
                this.$refs.jpjsAudio.style.top
            ) + this.moveY}px`;
        }
    }
    private touchEnd(e: any) {
        const ev = e || event;
        // @ts-ignore
        this.$refs.jpjsAudio.style.transition = "all 0.6s ease";
    }
    /* E 播放音乐 */
    /* S 计算当前位置在哪个景点 */
    @Watch("$store.state.routeArrow")
    getArrowData() {
        this.getRouteArrowData(this.$store.state.routeArrowData.nowIndex);
    }
    private computeInSecnic() {
        // 在景区范围内才计算，否则不计算
        if (localStorage.getItem("inSenic") === "true") {
            let pointList = this.$store.state.routePathPoint.spotList;
            if (pointList && pointList.length) {
                for (let i = 0, len = pointList.length; i < len; i++) {
                    let data = pointList[i];
                    if (
                        this.getDistanceNum(data.longitude, data.latitude) <
                        data.scope
                    ) {
                        console.log(`处于：${data.name}`);
                        this.saveTouristStay(data.id);
                        // this.socket.emit('onlineEvent',{
                        //     code:201,
                        //     data:data.id
                        // })
                        this.getRouteArrowData(i);
                        break;
                    }
                }
            }
        } else {
            this.$store.state.routeArrowData.show = false;
        }
    }
    // 获取当前索引的上下景点数据
    private getRouteArrowData(i: number) {
        this.setLBSimg(i);
        let pointList = this.$store.state.routePathPoint.pointList;
        let data = pointList[i];
        let arrowData = {
            show: false,
            showTo: "",
            nowIndex: i,
            nowID: data.pointId,
            nowName: data.pointName,
            prevID: "",
            prevName: "",
            nextID: "",
            nextName: ""
        };
        // 不为第一个点
        if (pointList[i - 1]) {
            arrowData.prevID = pointList[i - 1].pointId;
            arrowData.prevName = pointList[i - 1].pointName;
        }
        // 不为最后一个点
        if (pointList[i + 1]) {
            arrowData.nextID = pointList[i + 1].pointId;
            arrowData.nextName = pointList[i + 1].pointName;
        }
        if (this.$store.state.routeArrow && pointList[i + 1]) {
            // 正向行走，且下一个点存在；
            arrowData.show = true;
            arrowData.showTo = pointList[i + 1].pointName;
        } else if (!this.$store.state.routeArrow && pointList[i - 1]) {
            // 逆向行走，上一个点存在
            arrowData.show = true;
            arrowData.showTo = pointList[i - 1].pointName;
        }
        this.$store.commit("setRouteArrowData", arrowData);
    }
    // 设置当前lbs图
    private setLBSimg(i: number) {
        // @ts-ignore
        let map = window.mapObject;
        // 根据当前方向获取需要的数据
        let routData = this.$store.state.routePathPoint;
        let imgList = this.$store.state.routeArrow
            ? routData.lbsForwardImgs
            : routData.lbsReverseImgs;
        if (
            map &&
            imgList &&
            imgList.length &&
            i < routData.pointList.length - 1
        ) {
            this.$store.state.routeArrow ? "" : i--;
            // @ts-ignore 手绘图
            if (window.arrowImgLayer) {
                // @ts-ignore
                window.arrowImgLayer.setImageUrl(imgList[i]);
            } else {
                // @ts-ignore
                window.arrowImgLayer = new AMap.ImageLayer({
                    url: imgList[i],
                    bounds: new AMap.Bounds(
                        [routData.mapboundsLeft, routData.mapboundsBottom],
                        [routData.mapboundsRight, routData.mapboundsTop]
                    ),
                    zIndex: 108,
                    zooms: [12, 20],
                    map: map
                });
            }
        }
    }
    // 上传所在景点
    private saveTouristStay(id: number | string) {
        saveTouristStay({
            openId: localStorage.getItem("openId") || this.$store.state.openId,
            spotId: id
        }).then((res: any) => {});
    }
    private animatArrowImg() {
        setInterval(() => {
            // @ts-ignore
            let layer = window.arrowImgLayer,
                map = window.mapObject;
            if (layer && map && this.$store.state.routeArrowData.show) {
                layer.hide();
                setTimeout(() => {
                    layer.show();
                }, 700);
            }
        }, 1400);
    }
    /* E 计算当前位置在哪个景点 */
}
